import { Trash2, Mail, Phone } from "lucide-react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { http, errMsg } from "@/lib/api";

const STATI = ["nuova", "in lavorazione", "chiusa"];
const tone = { nuova: "bg-[var(--green)] text-white", "in lavorazione": "bg-[var(--brass)] text-[var(--ink)]", chiusa: "bg-gray-200 text-gray-700" };

export const RequestsAdmin = ({ items, reload }) => {
  const setStato = async (r, stato) => {
    try { await http.patch(`/admin/requests/${r.id}`, { stato }); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (r) => {
    if (!window.confirm("Eliminare questa richiesta?")) return;
    try { await http.delete(`/admin/requests/${r.id}`); reload(); } catch (e) { toast.error(errMsg(e)); }
  };

  if (!items.length) return <p data-testid="admin-requests-empty" className="bg-white border p-12 text-center text-[var(--mute-l)]">Nessuna richiesta ricevuta.</p>;

  return (
    <div data-testid="admin-requests" className="space-y-3">
      {items.map((r) => (
        <article key={r.id} data-testid={`admin-request-${r.id}`} className="bg-white border p-5 grid grid-cols-1 md:grid-cols-12 gap-4">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2">
              <span className={`text-[0.65rem] uppercase tracking-wider font-semibold px-2 py-0.5 ${tone[r.stato] || tone.nuova}`}>{r.stato}</span>
              <span className="text-xs text-[var(--mute-l)]">{new Date(r.created_at).toLocaleString("it-IT")}</span>
            </div>
            <p className="font-semibold mt-2">{r.nome}</p>
            <a href={`mailto:${r.email}`} className="text-sm flex items-center gap-1.5 text-[var(--green-deep)] hover:underline"><Mail className="w-3.5 h-3.5" />{r.email}</a>
            {r.telefono && <a href={`tel:${r.telefono}`} className="text-sm flex items-center gap-1.5 text-[var(--mute-l)]"><Phone className="w-3.5 h-3.5" />{r.telefono}</a>}
          </div>
          <div className="md:col-span-5 text-sm">
            <p className="text-xs text-[var(--mute-l)]">{r.tipologia}{r.agenzia ? ` · ${r.agenzia}` : ""}{r.listing_titolo ? ` · ${r.listing_titolo}` : ""}</p>
            {r.oggetto && <p className="font-semibold mt-1">{r.oggetto}</p>}
            <p className="mt-1.5 whitespace-pre-line">{r.messaggio}</p>
          </div>
          <div className="md:col-span-3 flex md:justify-end items-start gap-2">
            <Select value={r.stato} onValueChange={(v) => setStato(r, v)}>
              <SelectTrigger className="w-40" data-testid={`admin-request-stato-${r.id}`}><SelectValue /></SelectTrigger>
              <SelectContent>{STATI.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
            </Select>
            <Button size="icon" variant="ghost" onClick={() => remove(r)} data-testid={`admin-request-delete-${r.id}`}><Trash2 className="w-4 h-4 text-red-600" /></Button>
          </div>
        </article>
      ))}
    </div>
  );
};
